<ng-container *transloco="let t; read: 'home.calculator'">
  <div *ngIf="solarCalculatorResult" @inOutAnimation class="flex flex-col gap-10 justify-center items-center">
    <div class="w-full">
      <psc-solar-assessment
        [solarCalculatorResult]="solarCalculatorResult"></psc-solar-assessment>
      <psc-yearly-chart class=" mb-10" [solarCalculatorResult]="solarCalculatorResult"></psc-yearly-chart>
      <psc-return-on-investment-chart [solarCalculatorResult]="solarCalculatorResult"></psc-return-on-investment-chart>

      <psc-yearly-savings
        [powerPlant]="powerPlant"
        [extendedData]="true"
        [extendedDataBlurred]="true"
        [solarCalculatorResult]="solarCalculatorResult"></psc-yearly-savings>

      <psc-user-investment
        [solarCalculatorResult]="solarCalculatorResult"></psc-user-investment>
    </div>
  </div>

  <div class="relative">
    <div
      *pscRoleAccess="[UserRole.ROLE_PERSONAL]"
      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  z-20">
      <psc-pay-for-full
        [analysisId]="powerPlant?.analysisId"
        [userId]="powerPlant?.userId"></psc-pay-for-full>
    </div>
    <div class="grid gap-10 mt-10 blur-sm pointer-events-none">
      <psc-monthly-results-wrapper

        [solarCalculatorResult]="calculatorResultWrapper.result"></psc-monthly-results-wrapper>

      <psc-recalculate
        *pscRoleAccess="[UserRole.ROLE_PERSONAL]"
        [solarCalculatorResult]="solarCalculatorResult"></psc-recalculate>
    </div>
  </div>

  <psc-annotations></psc-annotations>

  <psc-dialog
    *ngIf="showSaveAndPayPowerPlantDialog"
    [title]="t('save_and_pay_dialog.title')"
    (closeClicked)="showSaveAndPayPowerPlantDialog = false">
    <psc-save-power-plant-form
      (plantSaved)="onSavedPlant($event)"
      (canceled)="showSaveAndPayPowerPlantDialog = false"
      [buttonText]="t('save_and_pay_dialog.submit')"
      [calculatorResultWrapper]="calculatorResultWrapper"></psc-save-power-plant-form>
  </psc-dialog>
</ng-container>
